import React from 'react';
import '../pages/About.css';

const AboutCard = ({ tittle, desc }) => {
  return (
    <div className='ab-sec3-card'>
      <h1>{tittle}</h1>
      {Array.isArray(desc) ? (
        <>
          <p className="desc-primary">{desc[0]}</p>  
          <p className="desc-secondary">{desc[1]}</p>  
        </>
      ) : (
        <p className="desc-default">{desc}</p>  
      )}
    </div>
  );
};

export default AboutCard;
